import Humanize from 'humanize-plus';
import { DateTime } from "luxon";
import { arrayAny } from '../../utils/arrayUtils';

export const FileManagerFolderMain = ({ folder, setPath, getImage, showCheckboxes, selected, setSelected }) => {

    return (
        <tr style={{ cursor: 'pointer' }} >

            {showCheckboxes && <td className="px-10px">
                <div className="form-check">
                    <input className="form-check-input" type="checkbox" checked={selected} onChange={() => setSelected(folder)} />
                </div>
            </td>}

            <td onClick={e => { e.stopPropagation(); setPath(folder); }} className="ps-10px border-0 text-center"><i className={`fa ${getImage('folder').icon} text-warning fa-lg`}></i></td>
            <td onClick={e => { e.stopPropagation(); setPath(folder); }} className="px-10px border-0">{folder.name}</td>
            <td className="px-10px">-</td>
            <td className="px-10px">-</td>
            <td className="px-10px">-</td>
            <td className="px-10px">Folder</td>
        </tr>
    );

};

const permDeletionMessage = (hasPreviousVersions, showingModal, file) => {

    if (!hasPreviousVersions && !showingModal && file.size === 0) {
        const userDeletedFileDate = file.deletedDate;
        const endOfRetentionPeriod = DateTime.fromFormat(userDeletedFileDate, "yyyy-MM-dd HH:mm:ss", { zone: 'utc' }).plus({ days: 6 });  // Azure will perm delete at this point...
        const nowUtc = DateTime.now();
        const diffInDays = Math.ceil(endOfRetentionPeriod.diff(nowUtc, 'days').days);
        return `None. File will be deleted in ${diffInDays} days.`;
    }
    return '';
};

export const FileManagerFileMain = ({ file, getImage, setShowPreviousModal, showingModal, setSelected, selected, showCheckboxes }) => {

    const hasPreviousVersions = arrayAny(file.previousVersions);
    const isDeleted = (hasPreviousVersions && file.size === 0);

    return (
        <tr >
            {showCheckboxes && <td className="px-10px">
                <div className="form-check">
                    <input className="form-check-input" type="checkbox" checked={selected} onChange={() => setSelected(file)} />
                </div>
            </td>}
            <td className="ps-10px border-0 text-center" title={getImage(file.contentType).description} ><i className={`far ${getImage(file.contentType).icon} text-body text-opacity-50 fa-lg`}></i></td>
            <td style={{ cursor: 'pointer' }} title={isDeleted ? 'Restore previous version to view it, current version is deleted.' : 'click to download/view'} className="px-10px border-0" onClick={() => { if (!isDeleted) { window.open(file.downloadUri, "_blank"); } }}>{file.name.split('/')[file.name.split('/').length - 1]}</td>
            {hasPreviousVersions && <td className="px-10px" onClick={() => setShowPreviousModal(file)} style={{ cursor: 'pointer' }} title='See previous versions' ><i className='fas fa-grip'></i></td>}
            {!hasPreviousVersions && !showingModal && file.size > 0 && <td>N/A</td>}
            {!hasPreviousVersions && !showingModal && file.size === 0 && <td>{permDeletionMessage(hasPreviousVersions, showingModal, file)}</td>}
            <td className="px-10px">{isDeleted || file.size === 0 ? "Deleted" : Humanize.fileSize(file.size)}</td>
            <td className="px-10px">{file.created}</td>
            <td className="px-10px">{file.modified}</td>
        </tr>
    );
};